import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { fetchEvents, createEvent, updateEvent, deleteEvent } from "../../API/AddEventApi";
import { FaEdit, FaTrash } from "react-icons/fa"; // Import icons
import "./AddEvent.css";

const AddEvents = () => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [startDate, setStartDate] = useState('');
  const [startTime, setStartTime] = useState(''); // New state for start time
  const [endDate, setEndDate] = useState('');
  const [endTime, setEndTime] = useState(''); // New state for end time
  const [location, setLocation] = useState('');
  const [files, setFiles] = useState([]); // For multiple file support
  const [eventList, setEventList] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editEventId, setEditEventId] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const eventsData = await fetchEvents();
        setEventList(eventsData);
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    formData.append('location', location);
    formData.append('startDate', startDate);
    formData.append('startTime', startTime); // Include start time
    formData.append('endDate', endDate);
    formData.append('endTime', endTime); // Include end time

    if (files.length > 0) {
      files.forEach((file) => {
        formData.append('images', file);
      });
    }

    try {
      if (isEditing) {
        await updateEvent(editEventId, formData);
        setIsEditing(false);
        setEditEventId(null);
      } else {
        await createEvent(formData);
      }

      // Reset form fields
      setTitle('');
      setDescription('');
      setStartDate('');
      setStartTime(''); // Reset start time
      setEndDate('');
      setEndTime(''); // Reset end time
      setLocation('');
      setFiles([]);

      // Fetch updated event list
      const updatedEvents = await fetchEvents();
      setEventList(updatedEvents);
    } catch (error) {
      console.error('Error saving event:', error.response || error.message);
    }
  };

  const handleEdit = (event) => {
    setIsEditing(true);
    setEditEventId(event._id);
    setTitle(event.title);
    setDescription(event.description);
    setStartDate(event.startDate.split('T')[0]); // Set date part
    setStartTime(event.startDate.split('T')[1].slice(0, 5)); // Set time part
    setEndDate(event.endDate.split('T')[0]); // Set date part
    setEndTime(event.endDate.split('T')[1].slice(0, 5)); // Set time part
    setLocation(event.location);
  };

  const handleDelete = async (id) => {
    try {
      await deleteEvent(id);
      setEventList((prevEvents) => prevEvents.filter((event) => event._id !== id));
    } catch (error) {
      console.error('Failed to delete event:', error.response ? error.response.data : error.message);
    }
  };

  return (
    <div className="container mt-5">
      <h2 className="text-center mb-3">Add Event</h2>
      <div className="row">
        {/* Form Container */}
        <div className="col-12 col-md-6">
          <form className="card p-4 mb-4 shadow-box" onSubmit={handleSubmit}>
            <div className="form-group mb-3">
              <label htmlFor="title">Title</label>
              <input
                type="text"
                className="form-control"
                id="title"
                placeholder="Enter title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="description">Description</label>
              <textarea
                className="form-control"
                id="description"
                rows="4"
                placeholder="Enter description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="startDate">Start Date and Time</label>
              <div className="row">
                <div className="col-6">
                  <input
                    type="date"
                    className="form-control"
                    id="startDate"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    required
                  />
                </div>
                <div className="col-6">
                  <input
                    type="time"
                    className="form-control"
                    id="startTime"
                    value={startTime}
                    onChange={(e) => setStartTime(e.target.value)}
                    required
                  />
                </div>
              </div>
            </div>
            <div className="form-group mb-3">
              <label htmlFor="endDate">End Date and Time</label>
              <div className="row">
                <div className="col-6">
                  <input
                    type="date"
                    className="form-control"
                    id="endDate"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    required
                  />
                </div>
                <div className="col-6">
                  <input
                    type="time"
                    className="form-control"
                    id="endTime"
                    value={endTime}
                    onChange={(e) => setEndTime(e.target.value)}
                    required
                  />
                </div>
              </div>
            </div>
            <div className="form-group mb-3">
              <label htmlFor="location">Location</label>
              <input
                type="text"
                className="form-control"
                id="location"
                placeholder="Enter event location"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                required
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="files">Images</label>
              <input
                type="file"
                className="form-control-file"
                id="files"
                multiple
                onChange={(e) => setFiles(Array.from(e.target.files))}
              />
            </div>
            <button type="submit" className="btn Submit-Btn">
              {isEditing ? 'Update' : 'Submit'}
            </button>
          </form>
        </div>

          {/* Old Events Section */}
          <div className="col-12 col-md-6">
            <div className="card p-4 old-events-container">
              <h5 className="mb-3">Old Events</h5>
              <div className="events-list">
                {eventList.length === 0 ? (
                  <p>No events found.</p>
                ) : (
                  eventList.map((event) => (
                    <div key={event._id} className="event-item mb-3 border p-3 rounded shadow-sm position-relative">
                      <h6 className="event-title font-weight-bold">{event.title}</h6>
                      <p className="event-description"><strong>Description:</strong> {event.description}</p>
                      <p className="event-date-time">
                        <strong>Start:</strong> {new Date(event.startDate).toLocaleString()} <br />
                        <strong>End:</strong> {new Date(event.endDate).toLocaleString()}
                      </p>
                      <p className="event-location"><strong>Location:</strong> {event.location}</p>

                      {/* Image Gallery Section */}
                      {event.images && event.images.length > 0 && (
                        <div className="image-gallery mb-2">
                          {event.images.map((image, index) => {
                            const imageUrl = `http://192.168.56.1:5001/uploads/events/${image}`;
                            return (
                              <img
                                key={index}
                                src={imageUrl}
                                alt={`Event Image ${index + 1}`}
                                className="img-fluid rounded"
                                style={{
                                  maxHeight: '200px',
                                  objectFit: 'cover',
                                  marginRight: '5px'
                                }}
                              />
                            );
                          })}
                        </div>
                      )}

                      {/* Icons Section aligned to the right */}
                      <div className="news-footer d-flex justify-content-between align-items-center">
                      <small className="text-muted date">
                        {new Date(event.createdAt).toLocaleDateString()}
                      </small>
                      <div className="icon-group">
                        <FaEdit
                          className="icon-button text-primary me-2"
                          onClick={() => handleEdit(event)}
                        />
                        <FaTrash
                          className="icon-button text-danger"
                          onClick={() => handleDelete(event._id)}
                        />
                      </div>
                    </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>

      </div>
    </div>
  );
};

export default AddEvents;
